var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-table',{attrs:{"data":_vm.data,"columns":_vm.columns,"draggable":""},on:{"dragstart":_vm.dragstart,"drop":_vm.drop,"dragover":_vm.dragover,"dragleave":_vm.dragleave}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }